import { inject } from '@angular/core';
import type { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { map, tap, withLatestFrom } from 'rxjs';
import { PagePath } from '../enums/page-path.enum';
import { AppStateService } from '../services/app-state.service';
import { GuardsContextService } from '../services/guards-context.service';
import { NavigationService } from '../services/navigation.service';

export const retailCostsSelectedGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  guardsContextService = inject(GuardsContextService),
  appStateService = inject(AppStateService),
  navigationService = inject(NavigationService)
) => {
  return guardsContextService.getIsProcessingAuth$().pipe(
    withLatestFrom(appStateService.isMailOrderCostsSelected$()),
    tap(([isProcessingAuth, isMailOrderCostsSelected]) => {
      if (!isProcessingAuth && isMailOrderCostsSelected) {
        navigationService.navigateToPagePath([PagePath.ACCOUNT_PRESCRIPTIONS]);
      }
    }),
    map(([isProcessingAuth, isMailOrderCostsSelected]) => isProcessingAuth || !isMailOrderCostsSelected)
  );
};
